import { isMobileDevice, shareLink } from '@/utils';

export { isMobileDevice };

export const getAchievementShareUrl = (shareId: string): string =>
	`${window.location.origin}/a/${shareId}`;

export async function shareAchievementLink({
	url,
	message,
	skipMobileCheck,
}: {
	url: string;
	message: string;
	skipMobileCheck?: boolean;
}): Promise<void> {
	return shareLink({ url, message, skipMobileCheck });
}
